import React from 'react'

export const PoweredBy = () => (
  <div className="powered-container">
    <div className='powered-text'>Powered By</div>
    <img
      className='powered-img'
      alt="The Ticket Fairy"
      src={"https://cdn-checkout.s3.us-east-2.amazonaws.com/IconTicketFairy.svg"}
    />
    <div className='powered-ttf'>
      The<strong>Ticket</strong>Fairy
    </div>
  </div>
)
